import { MIDDLE_OFFICE_APPLICATION_ROUTES } from './applications';
import { MIDDLE_OFFICE_AUTH_ROUTES } from './auth';
import { MIDDLE_OFFICE_REDIRECT_ROUTES } from './redirects';
import { MIDDLE_OFFICE_SETTINGS_ROUTES } from './settings';
import { MIDDLE_OFFICE_SYSTEM_ROUTES } from './system';

export {
  MIDDLE_OFFICE_APPLICATION_BASE_URL,
  MIDDLE_OFFICE_APPLICATIONS_BASE_URL,
} from './applications';
export { MIDDLE_OFFICE_RESET_BASE_URL } from './auth';
export {
  MIDDLE_OFFICE_ADMIN_BASE_URL,
  MIDDLE_OFFICE_SETTINGS_BASE_URL,
} from './settings';

export const MIDDLE_OFFICE_ROUTES = {
  ...MIDDLE_OFFICE_AUTH_ROUTES,
  ...MIDDLE_OFFICE_APPLICATION_ROUTES,
  ...MIDDLE_OFFICE_SETTINGS_ROUTES,
  ...MIDDLE_OFFICE_REDIRECT_ROUTES,
  ...MIDDLE_OFFICE_SYSTEM_ROUTES,
} as const;
